function modalsReducer(state, action) {
  switch (action.type) {
    case "OPEN": {
      return {
        current: action.payload,
        modals: [...state.modals, action.payload]
      };
    }
    case "CLOSE": {
      const modals = state.modals.filter((m) => m.id !== action.payload);
      return {
        current: modals[modals.length - 1] || state.current,
        modals
      };
    }
    case "CLOSE_ALL": {
      return {
        current: state.current,
        modals: []
      };
    }
    default: {
      return state;
    }
  }
}

export { modalsReducer };
//# sourceMappingURL=reducer.js.map
